/* globals __CLIENT__ */

export const TARGET_TYPE = {
  BANNER: 'Banner',
  OVERLAY: 'Overlay',
};

export default (targetType) => {
  if (__CLIENT__) {
    const pathname = '/login';
    const returnUrl = encodeURIComponent(
      `${location.pathname}${location.search}${(location.search ? '&' : '?')}fromLoginPrompt${targetType}=true${location.hash}`,
    );
    return `${pathname}?returnUrl=${returnUrl}`;
  }
  return '/';
};



// WEBPACK FOOTER //
// ./app/src/components/LoginPrompt/getLinkTarget.js